import {FileService} from './../shared/services/fileService';
import {EmployeeSearch} from './admin/controller/employeeSearch.component';
import {ToasterComponent} from './admin/controller/toasterComponent';
import {NgModule} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpModule} from '@angular/http';
import {TreeModule} from 'angular-tree-component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DatePipe} from '@angular/common';
import {DndModule} from 'ng2-dnd';
import {MentionModule} from 'angular-mentions/mention';
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
//ADMIN-MDM-COMPONENTS
import {CubeComponent} from './admin/controller/cube.component';
import {DimensionComponent} from './admin/controller/dimension.component';
import {DataSourceComponent} from './admin/controller/dataSource.component';
import {MeasureComponent} from './admin/controller/measure.component';
import {UomComponent} from './admin/controller/uom.component';
import {ScopeComponent} from './admin/controller/scope.component';
import {ValueStreamComponent} from './admin/controller/valueStream.component';
import {RecordFormatComponent} from './admin/controller/recordFormat.component';
import {AdminPage} from './admin/controller/adminPage.component';
import {pageAuthorizationComponent} from './admin/controller/pageAuthorization.component';
import {roleAuthorizationComponent} from './admin/controller/roleAuthorization.component';
import {editRoleAuthorizationComponent} from './admin/controller/editRoleAuthorization.component';
import {dimLvlPermComponent} from './admin/controller/dimLvlPermissions.component';
import {tenantConfigComponent} from './admin/controller/tenantConfiguration.component';
import {targetComponent} from './admin/controller/target.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {MeasureEditComponent} from './admin/controller/measureEdit.component'
import {DimensionEditComponent} from './admin/controller/dimensionEdit.component';
import {FileUploader} from './admin/controller/fileUploadModal';
import {POCWizard} from './admin/pocdesigner/pocWizard.component';
import {DesignerCube} from './admin/pocdesigner/designerCube.component';
import {DataMapper} from './admin/pocdesigner/dataMapper';
import {DataPreview} from './admin/pocdesigner/dataPreview';
//CONFIGURATION
import {Loader} from './admin/controller/loader.component';
import {DataEngine} from './admin/controller/dataEngine.component';
//ADMIN-MDM-SERVICES
import {MDMService} from './admin/services/mdmService.service';
import {RoleAuthService} from './admin/services/roleAuthService.service';

import {NumberUtils} from './common/service/number.utils';
import {TimeUtils} from './common/service/time.utils';
//GENERIC SERVICES
import {Ng2AutoCompleteModule} from 'ng2-auto-complete';
import {PreloadAllModules, RouterModule} from '@angular/router';
import {ROUTES} from '../app.routes';
import {NgbDateConverter} from './common/service/ngbDateConverter.utils';
import {NgbTimeConverter} from './common/service/ngbTimeConverter.utils';
import {EmployeeFilterModule} from './../employee/employeeFilter.module';

// import { HighChartDataParser } from './common/service/highchart-data-parser';


const ngbModule = NgbModule.forRoot();
const dndModule = DndModule.forRoot();
const routModule = RouterModule.forRoot(ROUTES, {
    useHash: Boolean(history.pushState) === true,
    preloadingStrategy: PreloadAllModules
})


@NgModule({
    entryComponents: [FileUploader],

    declarations: [CubeComponent, DataSourceComponent, AdminPage,
        pageAuthorizationComponent, roleAuthorizationComponent, editRoleAuthorizationComponent, dimLvlPermComponent, DimensionComponent,
        MeasureComponent, UomComponent, ScopeComponent, Loader, ValueStreamComponent,
        RecordFormatComponent, targetComponent, tenantConfigComponent,
        DataEngine,
        EmployeeSearch, MeasureEditComponent, DimensionEditComponent, FileUploader, POCWizard, DesignerCube, DataMapper, DataPreview],

    imports: [BrowserModule, FormsModule, ReactiveFormsModule, Ng2AutoCompleteModule, TreeModule, AngularMultiSelectModule,
        HttpModule, BrowserAnimationsModule,
        ngbModule,
        dndModule,
        routModule,
        MentionModule,
        EmployeeFilterModule],

    providers: [MDMService, RoleAuthService, NumberUtils, NgbDateConverter, NgbTimeConverter, 
                FileService, TimeUtils, DatePipe, ToasterComponent]
})

export class BIAdminModule {

}



// WEBPACK FOOTER //
// ./src/app/bi/index.ts